<template></template>

<script>
import Swal from 'sweetalert2';

export default {
  props: {
    show: Boolean,
    type: { type: String, default: 'success' },
    title: { type: String, default: '' },
    text: { type: String, default: '' },
    confirmText: { type: String, default: 'OK' },
    link: { type: String, default: null },
  },

  mounted() {
    if (this.show) {
      this.showAlert();
    }
  },

  methods: {
    showAlert() {
      Swal.fire({
        title: this.title,
        text: this.text,
        icon: this.type,
        confirmButtonColor: '#D20B12',
        confirmButtonText: this.confirmText,
      }).then((result) => {
        if (result.isConfirmed) {
          if (this.link) {
            window.location.href = this.link;
          } else {
            this.$emit('close');
          }
        }
      });
    },
  },

  watch: {
    show(val) {
      if (val) {
        this.showAlert();
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/js/app/components/SwAlert.vue